import * as React from "react";
const IconSessionName = (props) => (
  <svg
    width={22}
    height={21}
    viewBox="0 0 22 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3_91995)">
      <path
        d="M1.7251 11.6947H1.0751V12.9947H1.7251V11.6947ZM20.2476 12.9947H20.8976V11.6947H20.2476V12.9947ZM8.20796 19.1037C7.84897 19.1037 7.55796 19.3947 7.55796 19.7537C7.55796 20.1126 7.84897 20.4037 8.20796 20.4037V19.1037ZM13.7647 20.4037C14.1237 20.4037 14.4147 20.1126 14.4147 19.7537C14.4147 19.3947 14.1237 19.1037 13.7647 19.1037V20.4037ZM11.6363 16.0492C11.6363 15.6902 11.3453 15.3992 10.9863 15.3992C10.6273 15.3992 10.3363 15.6902 10.3363 16.0492H11.6363ZM4.50347 1.8812H17.4692V0.581201H4.50347V1.8812ZM19.5976 4.00957V13.2708H20.8976V4.00957H19.5976ZM17.4692 15.3992H4.50347V16.6992H17.4692V15.3992ZM2.3751 13.2708V4.00957H1.0751V13.2708H2.3751ZM4.50347 15.3992C3.328 15.3992 2.3751 14.4463 2.3751 13.2708H1.0751C1.0751 15.1642 2.61003 16.6992 4.50347 16.6992V15.3992ZM19.5976 13.2708C19.5976 14.4463 18.6447 15.3992 17.4692 15.3992V16.6992C19.3626 16.6992 20.8976 15.1642 20.8976 13.2708H19.5976ZM17.4692 1.8812C18.6447 1.8812 19.5976 2.8341 19.5976 4.00957H20.8976C20.8976 2.11613 19.3626 0.581201 17.4692 0.581201V1.8812ZM4.50347 0.581201C2.61003 0.581201 1.0751 2.11613 1.0751 4.00957H2.3751C2.3751 2.8341 3.328 1.8812 4.50347 1.8812V0.581201ZM1.7251 12.9947H20.2476V11.6947H1.7251V12.9947ZM8.20796 20.4037H10.9863V19.1037H8.20796V20.4037ZM10.9863 20.4037H13.7647V19.1037H10.9863V20.4037ZM11.6363 19.7537V16.0492H10.3363V19.7537H11.6363Z"
        fill="#1C1C2C"
      />
    </g>
    <defs>
      <clipPath id="clip0_3_91995">
        <rect width={21} height={21} fill="white" transform="translate(0.486328 -0.00756836)" />
      </clipPath>
    </defs>
  </svg>
);
export default IconSessionName;
